import React from "react";

import { ToastContainer } from "react-toastify";
import { Container } from "reactstrap";
import ProductivityGraphicsWrapper from "./Graphics/ProductivityGraphicsWrapper";
import ProductivityCardsWrapper from "./Cards/ProductivityCardsWrapper";
import ProductivityVisitsTable from "./Tables/ProductivityVisitsTable";
import InstalledTrapsByUserTable from "./Tables/InstalledTrapsByUserTable";
import ReadedTrapsByUserTable from "./Tables/ReadedTrapsByUserTable";
import UninstalledTrapsByUserTable from "./Tables/UninstalledTrapsByUserTable";
import { ProductivityPageHeader } from "./ProductivityPageHeader";
import useDemandsList from "../../../hooks/useDemandsList";
import useEmployeesList from "../../../hooks/useEmployeesList";
import useTeamsList from "../../../hooks/useTeamsList";
import useTerritorializationsList from "../../../hooks/useTerritorializationsList";
import useTypeLayersList from "../../../hooks/useTypeLayersList";
import {
  fetchDemandsData,
  fetchEmployeesAndTeamsData,
  fetchTerritorializationsData,
} from "../../../services/utils/globalFunctions";
import { useProductivity } from "./Hooks/useProductivity";
import useAppliedFilters from "./Hooks/useAppliedFilters";

const useProductivityPage = () => {
  const { demandsList, setDemandsList } = useDemandsList();
  const { employeesList, setEmployeesList } = useEmployeesList();
  const { teamsList, setTeamsList } = useTeamsList();
  const { territorializationsList, setTerritorializationsList } =
    useTerritorializationsList();
  const { typeLayersList, setTypeLayersList } = useTypeLayersList();
  const { productivityData } = useProductivity();
  const { appliedFilters } = useAppliedFilters();

  React.useEffect(() => {
    if (demandsList.length === 0) fetchDemandsData(setDemandsList);

    if (territorializationsList.length === 0 || typeLayersList.length === 0)
      fetchTerritorializationsData(
        setTerritorializationsList,
        setTypeLayersList
      );

    if (teamsList.length === 0 || employeesList.length === 0)
      fetchEmployeesAndTeamsData(setEmployeesList, setTeamsList);
  }, []);

  return {
    appliedFilters,
    productivityData,
    employeesList,
    territorializationsList,
  };
};

const ProductivityPage = () => {
  const {
    productivityData,
    appliedFilters,
    employeesList,
    territorializationsList,
  } = useProductivityPage();

  return (
    <main>
      <ToastContainer />
      <Container
        style={{ paddingBottom: "2rem !important" }}
        fluid
        className="bg-gradient-info pt-5 pb-2 mb-5"
      >
        <div style={{ paddingTop: "10px !important", color: "#6d6d6d" }}>
          &nbsp;
        </div>
        <ProductivityPageHeader />
      </Container>
      <Container fluid className="pb-2 mt-2">
        <ProductivityCardsWrapper
          fieldProductivityData={productivityData.fieldProductivity}
          typingProductivityData={productivityData.typingProductivity}
          visitsByStatusData={productivityData.visitsStatus}
        />
        <ProductivityGraphicsWrapper
          productivityByAreas={productivityData.productivityByAreas}
          fieldProductivityData={productivityData.fieldProductivity}
          typingProductivityData={productivityData.typingProductivity}
          visitsByStatusData={productivityData.visitsStatus}
          consolidatedVisits={productivityData.consolidatedVisits}
          goalsData={productivityData.goalsData}
          employeesList={employeesList}
          territorializationsData={territorializationsList}
          productivityFilters={appliedFilters}
        />
        <ProductivityVisitsTable
          visitsData={productivityData.visitsStatus}
          employees={employeesList}
          productivityFilters={appliedFilters}
        />
        <InstalledTrapsByUserTable
          visitsData={productivityData.consolidatedVisits}
          employees={employeesList}
          productivityFilters={appliedFilters}
        />
        <ReadedTrapsByUserTable
          visitsData={productivityData.consolidatedVisits}
          employees={employeesList}
          productivityFilters={appliedFilters}
        />
        <UninstalledTrapsByUserTable
          visitsData={productivityData.consolidatedVisits}
          employees={employeesList}
          productivityFilters={appliedFilters}
        />
      </Container>
    </main>
  );
};

export default ProductivityPage;
